export const EZ = 'ez';
export const HPC = 'hpc';
export const CR = 'cr';
export const DISABLED = 'disabled';
